import React, { useCallback } from "react";
import { Button, Modal } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import ee from "../../../../services/EventEmitter";
import { MODAL } from "../../../../constants/translates";
import { DELETE_CMR_ENTITY } from "../../../../constants/events";
import Authorize from "../../../Authorize";
import { CAN_DELETE_CMR } from "../../../../constants/authorize";

interface Props {
  id: number;
}

const Delete: React.FC<Props> = ({ id }) => {
  const onDeleteHandler = useCallback(() => {
    Modal.confirm({
      title: MODAL.confirm_title,
      content: MODAL.confirm_delete,
      onOk: () => {
        ee.emit(DELETE_CMR_ENTITY, id);
      },
    });
  }, [id]);

  return (
    <Authorize permission={[CAN_DELETE_CMR]}>
      <Button type="primary" onClick={onDeleteHandler}>
        <DeleteOutlined />
      </Button>
    </Authorize>
  );
};

export default Delete;
